class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.data = this.querySelector("#product-json");
    this.variantListeners = this.querySelectorAll("[data-variant-listener]");
    this.freeShipping = this.querySelector("#product-form__free-shipping");
    this.productId = this.dataset.productId;
    try {
      this.fallBackOptions = JSON.parse(this.dataset.fallbackOptions);
    } catch (e) {
      this.fallBackOptions = null;
    }
    this.disabledFallBackOptions = [];
    this.variantOptions = this.querySelectorAll(`[data-variant-option]`);
    this.subOption = this.querySelector(
      `product-options[data-subscription-option]`
    );
    this.disabledOptions = this.querySelector(
      "#disabled-options-" + this.productId
    );
    this.modelButton = this.querySelector(".view-3d-modal__icon");
    this.benefitsContainers =
      this.querySelectorAll(
        `[data-product-benefits="benefits-${this.productId}"]`
      ) || [];
    this.productForm = this.querySelector('[data-product-form="true"]');
    this.mediaContainers = Array.from(
      this.querySelectorAll(
        `[data-product-media="media-${this.productId}"] img`
      )
    );
    this.quantitySelector = this.querySelector("quantity-input");
    this.quantity = 1;
    this.priceContainers = this.querySelectorAll(
      `[data-product-price="price-${this.productId}"]`
    );
    this.pricePerMonthContainers = this.querySelectorAll(
      `[data-product-price-pm="price-pm-${this.productId}"]`
    );
    this.priceTotalContainers = this.querySelectorAll(
      `[data-product-price-total="price-total-${this.productId}"]`
    );
    this.nonDiscountedPriceContainers = this.querySelectorAll(
      `[data-product-price-nd="price-nd-${this.productId}"]`
    );
    this.subPriceContainers = this.querySelectorAll(
      `[data-product-sub-price="sub-price-${this.productId}"]`
    );
    this.comparePriceContainers = this.querySelectorAll(
      `[data-product-compare-price="compare-price-${this.productId}"]`
    );
    this.variantTitlesContainers = this.querySelectorAll(
      `[data-variant-title="variant-title-${this.productId}"]`
    );
    this.bundleContainers = this.querySelectorAll("[data-bundle-save]");
    this.load();
  }

  load() {
    try {
      this.data = this.querySelector("#product-json");
      this.productData = JSON.parse(this.data.textContent);
      this.pdpCarousel = this.querySelector("custom-carousel");
      this.updateOptions();
      this.updateDisabledOptions();
      this.getAvailableVariants();
      this.addListeners();
    } catch (e) {
      this.productData = null;
    }
  }

  updateDisabledOptions() {
    if (this.disabledOptions) {
      if (!this.disabledOptionsData) {
        this.disabledOptionsData = JSON.parse(this.disabledOptions.textContent);
        if (this.fallBackOptions) {
          const cache = [];
          this.disabledOptionsData.filter((options, index) => {
            const otherFallBackOptions = this.fallBackOptions.filter(
              (i) => options.indexOf(i) === -1
            );
            const nonFallBackOptions = options.filter(
              (i) => this.fallBackOptions.indexOf(i) === -1
            );
            this.disabledOptionsData.forEach((option) => {
              if (
                option.every(
                  (o) =>
                    otherFallBackOptions.indexOf(o) !== -1 ||
                    nonFallBackOptions.indexOf(o) !== -1
                )
              ) {
                cache.push(option);
              }
            });
          });
          this.disabledOptionsData = cache;
        }
      }
      let disabled = this.getDisabledOptions().flat() || [];
      this.variantOptions.forEach((node) => {
        if (
          disabled.find(
            (j) => j.toLowerCase().trim() === node.value.toLowerCase().trim()
          )
        )
          node.setAttribute("data-oos", true);
      });
    }
  }
  getDisabledOptions() {
    const disabled = [];
    if (this.optionsValues.length < 2) {
      this.disabledOptionsData.forEach((i) => disabled.push(i));
    } else {
      this.optionsValues.forEach((option) => {
        const otherSelectedOptions = this.optionsValues.filter(
          (i) => i !== option
        );
        this.disabledOptionsData.forEach((j) => {
          if (
            otherSelectedOptions.every((i) => {
              return j.indexOf(i) !== -1;
            })
          ) {
            disabled.push(
              j.filter((l) => otherSelectedOptions.indexOf(l) === -1)
            );
          }
        });
      });
    }
    return disabled;
  }

  onVariantChange(evt) {
    if (!this.data) {
      return;
    }
    this.updateOptions();
    if (this.subOption) {
      this.updateSubOptions();
    }
    this.getCurrentVariant(evt);
    this.updateUrl();
    this.updatePrices();
    if (this.productForm) {
      this.updateForm();
    }
  }

  getAvailableVariants() {
    this.availableVariants = [];
    this.productData.variants.forEach((variant) => {
      if (variant.available) {
        this.availableVariants.push(variant.options);
      }
    });
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
    if (this.quantitySelector) {
      this.quantitySelector.addEventListener(
        "change",
        this.updatePrices.bind(this)
      );
    }
  }

  updateSubOptions() {
    this.subValue = this.subOption.querySelector("input:checked").value;
    if (this.productForm) {
      this.productForm.querySelector('[name="properties[_interval]"]').value =
        this.subValue;
    }
  }

  updateOptions() {
    this.optionsNodes = this.querySelectorAll(
      "input:checked[data-variant-option],select[data-variant-option]"
    );
    if (this.optionsNodes) {
      this.optionsValues = Array.from(this.optionsNodes).map((i) => i.value);
      return;
    }
    this.optionsValues = [];
  }

  getCurrentVariant(evt) {
    let result = this.productData.variants.find((variant) => {
      return this.optionsValues.every((option) =>
        variant.options.includes(option)
      );
    });
    if (this.fallBackOptions && !result.available) {
      const otherOptions = this.optionsValues.filter(
        (option) => this.fallBackOptions.indexOf(option) === -1
      );
      const otherFallbackOptions = this.fallBackOptions.filter(
        (i) => this.optionsValues.indexOf(i) === -1
      );
      result = this.productData.variants.find((variant) => {
        for (let o = 0; o < otherFallbackOptions.length; o++) {
          const optionsSearch = [...otherOptions, otherFallbackOptions[o]];
          if (
            optionsSearch.every(
              ((op) => variant.options.indexOf(op) !== -1) ||
                o === otherFallbackOptions.length - 1
            )
          ) {
            return true;
          }
        }
      });
    }
    if (!result) {
      this.updateOptionsData(false);
      return;
    }
    if (
      !this.currentVariant ||
      (this.currentVariant && this.currentVariant.id !== result.id)
    ) {
      this.currentVariant = result;
    }
    if (this.variantTitlesContainers.length)
      this.variantTitlesContainers.forEach((node) => {
        let delimiter = "<span class='divider'>•</span>";
        let variant_text = "";
        variant_text = this.currentVariant.title
          .split("/")
          .map((item, index) => {
            return `<span class='variant-title__item'>${item}</span> `;
          })
          .join(delimiter);
        node.innerHTML = variant_text;
      });
    if (this.variantListeners) {
      this.variantListeners.forEach((j) =>
        j.setAttribute(j.dataset.variantListener, this.currentVariant.id)
      );
    }
    if (this.benefitsContainers.length) {
      const current_benefits = this.currentVariant.top_benefits || null;
      this.benefitsContainers.forEach((node) => {
        node.innerHTML = current_benefits;
      });
    }
    if (this.modelButton) {
      const model =
        this.productData &&
        this.productData.models.length &&
        this.productData.models.find((modelItem) =>
          this.currentVariant.options.find(
            (option) =>
              modelItem &&
              modelItem.alt &&
              modelItem.alt.toLowerCase().includes("_" + option.toLowerCase())
          )
        );
      if (!model) {
        this.modelButton.classList.add("hidden");
      } else {
        this.modelButton.classList.remove("hidden");
      }
    }
    if (evt.target.dataset.variantOption === "true") {
      if (evt.target.dataset.changePdpMedia === "true" && this.pdpCarousel) {
        this.changeMediaPDP();
      }
      this.updateOptionsData(this.currentVariant.available);
      this.dispatchEvent(
        new CustomEvent("variant-change", {
          detail: {
            currentVariant: this.currentVariant,
            shouldChangePdpMedia: evt.target.dataset.changePdpMedia === "true",
          },
          bubbles: false,
        })
      );
    }
  }

  updateOptionsData(available) {
    if (!this.optionsNodes.length) return;
    this.variantOptions.forEach((option) => {
      option.removeAttribute("data-oos");
      let marketAvailability = true;
      if (this.productForm)
        marketAvailability =
          this.productForm
            .querySelector("button")
            .getAttribute("data-market-availability") !== "false";
      if (this.productForm && marketAvailability) {
        this.productForm
          .querySelectorAll("button.product-form__submit")
          .forEach((i) => i.removeAttribute("disabled"));
      }
    });
    if (!available) {
      this.optionsNodes.forEach((i) => {
        i.setAttribute("data-oos", true);
        if (i.tagName.toLowerCase() === "select") {
          let disabled = this.getDisabledOptions().flat() || [];
          let options = Array.prototype.slice.call(i.childNodes);
          options.forEach((k) => {
            if (!k.value) return;
            if (disabled.includes(k.value.toLowerCase().trim())) {
              k.setAttribute("data-oos", true);
            }
          });
        }
      });
      if (this.productForm) {
        this.productForm.querySelectorAll("button").forEach((btn) => {
          btn.disabled = true;
        });
      }
    }
    this.updateDisabledOptions();
  }

  changeMediaPDP() {
    const mediaChangeEvent = new CustomEvent("media-change", {
      detail: [
        ...this.currentVariant.media,
        ...this.productData.images_no_variants,
      ],
    });
    this.dispatchEvent(mediaChangeEvent);
  }

  updatePrices() {
    if (!this.currentVariant) return;
    if (this.quantitySelector)
      this.quantity = this.quantitySelector.getQuantity();

    const subscriptionDiscount =
      (this.currentVariant.price * this.productData.subscription_discount) /
      100;
    const currentVariantPrice = this.subValue
      ? this.currentVariant.price - subscriptionDiscount
      : this.currentVariant.price;
    const discountedVariantPrice =
      this.currentVariant.price - subscriptionDiscount;
    const totalPrice = currentVariantPrice * this.quantity;
    if (this.freeShipping) this.handleFreeShipping(totalPrice);
    this.dispatchEvent(new CustomEvent("productPriceChange", { detail: totalPrice }));
    this.priceContainers.forEach((i) => {
      if (i.dataset.formItem === "true" && !this.currentVariant.available) {
        i.innerText = theme.translations.sold_out;
        return;
      } else {
        i.innerHTML = formatMoney(currentVariantPrice).toUpperCase();
      }
    });
    this.priceTotalContainers.forEach((i) => {
      if (i.dataset.formItem === "true" && !this.currentVariant.available) {
        i.innerText = theme.translations.sold_out;
        return;
      } else {
        i.innerText = formatMoney(totalPrice);
      }
    });
    this.pricePerMonthContainers.forEach((node) => {
      node.innerText = formatMoney(
        discountedVariantPrice / this.productData.subscription_interval
      );
    });
    this.subPriceContainers.forEach((node) => {
      node.innerText = formatMoney(discountedVariantPrice);
    });
    this.nonDiscountedPriceContainers.forEach((node) => {
      node.innerText = formatMoney(this.currentVariant.price);
    });
    if (this.subOption) {
      this.subOption
        .querySelectorAll("[data-product-save]")
        .forEach(
          (s) =>
            (s.innerHTML = formatMoney(
              this.currentVariant.price - discountedVariantPrice
            ).toUpperCase())
        );
    }
    this.comparePriceContainers.forEach((i) => {
      const currentPrice = +Number(i.innerHTML).toFixed(2);
      const bundle_total_price = Number(this.currentVariant.bundle_total_price);
      const compare_at_price = Number(this.currentVariant.compare_at_price);
      if (compare_at_price > 0 && compare_at_price !== currentPrice) {
        i.innerHTML = formatMoney(compare_at_price).toUpperCase();
        return;
      }
      if (bundle_total_price !== currentPrice) {
        i.innerHTML = formatMoney(bundle_total_price).toUpperCase();
      }
    });
    this.bundleContainers.forEach((node) => {
      const totalPriceBundle =
        this.currentVariant.compare_at_price ||
        this.currentVariant.bundle_total_price ||
        this.currentVariant.price;
      node.innerText = Math.ceil(
        100 - (currentVariantPrice * 100) / totalPriceBundle
      );
    });
  }
  handleFreeShipping(totalPrice) {
    if (totalPrice > theme.shop.free_shipping * 100) {
      this.freeShipping.classList.replace('d-none', 'd-flex')
    } else {
      this.freeShipping.classList.replace('d-flex', 'd-none')
    }
  }
  updateForm() {
    if (!this.productForm || !this.currentVariant) return;
    this.productForm.querySelector("input[name='id']").value =
      this.currentVariant.id;
  }

  updateUrl() {
    const url = new URL(window.location.href);
    if (this.currentVariant && this.currentVariant.id)
      url.searchParams.set("variant", this.currentVariant.id);
    history.replaceState({ path: url.toString() }, "", url.toString());
  }
}

if (!customElements.get("main-product")) {
  customElements.define("main-product", MainProduct);
}

class ProductVariantSelects extends MainProduct {
  constructor() {
    super();
  }

  load() {
    this.productData = null;
    if (this.dataset.productDetail) {
      const json = this.querySelector("#" + this.dataset.productDetail);
      try {
        this.productData = JSON.parse(json.textContent);
        this.variantsData = this.productData.variants;
      } catch (e) {
        logger.error(e);
      }
    }
    this.urlContainers = this.querySelectorAll(
      `[data-product-url="url-${this.productId}"]`
    );
    this.updateOptions();
    this.updateDisabledOptions();
    this.addListeners();
  }

  addListeners() {
    this.addEventListener("change", this.onVariantChange);
  }

  async onVariantChange(evt) {
    if (!this.productData) {
      await this.loadData();
      this.getAvailableVariants();
    }
    if (this.variantsData) {
      this.updateOptions();
      if (this.subOption) {
        this.updateSubOptions();
      }
      this.getCurrentVariant(evt);
      this.updatePrices();
      this.updateMedia();
      this.updateForm();
      this.updateURL();
    }
  }

  async loadData() {
    await apiFetchText(`${this.dataset.url}`, "?view=product-json").then(
      (responseText) => {
        const html = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("#product-json");
        try {
          this.productData = JSON.parse(html.textContent);
          this.variantsData = this.productData.variants;
        } catch (e) {
          this.productData = null;
        }
      }
    );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (this.currentVariant.featured_media) {
      let _this = this;
      if (this.mediaContainers) {
        this.mediaContainers.forEach((i) => {
          const mediaQuery = i.src.split("?")[1] || "";
          if (
            i.classList.contains("product-card__hover-asset") &&
            this.currentVariant.hover_media
          ) {
            i.srcset = `${this.currentVariant.hover_media.src}?${mediaQuery}`;
            i.alt = this.currentVariant.hover_media.alt;
          } else {
            i.srcset = `${this.currentVariant.featured_media.preview_image.src}?${mediaQuery}`;
            i.alt = this.currentVariant.featured_media.preview_image.alt;
          }
          i.onload = function () {
            i.style.transition = "unset";
            i.style.opacity = 0;
            setTimeout(() => {
              i.style.transition = "opacity .6s ease,transform .5s";
              i.style.opacity = 1;
            }, 200);
          };
        });
      }
    }
  }
  updateURL() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.available) return;
    if (this.urlContainers.length) {
      this.urlContainers.forEach((i) => {
        i.href = `${this.dataset.url}?variant=${this.currentVariant.id}`;
      });
    }
  }
}

if (!customElements.get("product-item-variant-selector")) {
  customElements.define("product-item-variant-selector", ProductVariantSelects);
}

class ProductOptions extends HTMLElement {
  constructor() {
    super();
    this.optionName = this.dataset.optionName;
    this.labelValues = this.querySelectorAll("[data-option-value]");
    this.addListeners();
    this.initSelectedOptionFromQuery();
  }

  selectOptionByValue(optionKey) {
    const optionValue = theme.translations.option_values[optionKey];
    const optionValueMap = theme.translations.option_values_map[optionKey];
    const option =
      this.querySelector(`[value="${optionValue}"]`) ||
      this.querySelector(`[value="${optionValueMap}"]`);
    if (option) {
      option.click();
      this.setAttribute("data-option-set-from-query", true);
    }
  }

  initSelectedOptionFromQuery() {
    try {
      const params = new URLSearchParams(window.location.search);
      this.selectOptionByValue(params.get("skin_type")); // We can add others as needed
    } catch (error) {
      // swallow
    }
  }

  addListeners() {
    if (this.labelValues) {
      this.addEventListener("change", (evt) => {
        this.querySelectorAll(
          ".product-options__subscription-option-wrapper"
        ) &&
          this.querySelectorAll(
            ".product-options__subscription-option-wrapper"
          ).forEach((node) => node.classList.remove("active"));
        if (evt.target.closest(".product-options__subscription-option-wrapper"))
          evt.target
            .closest(".product-options__subscription-option-wrapper")
            .classList.add("active");
        this.labelValues.forEach((j) => (j.innerHTML = evt.target.value));
      });
    }
  }
}

customElements.define("product-options", ProductOptions);
